(function () {
    // Fixed: Largest Contentful Paint image was lazily loaded
    const first_image = document.querySelector('#MainContent .shopify-section .media img');
    if (first_image) first_image.setAttribute('loading', 'auto');
})();

window.addEventListener('DOMContentLoaded', () => {
    const loadVideos = document.querySelectorAll('.load-video');
    if (loadVideos.length > 0) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const video = entry.target;

                    if (entry.intersectionRatio > 0.2) {
                        video.play();
                    } else {
                        video.pause();
                    }
                });
            },
            {
                threshold: 0.2,
            }
        );

        loadVideos.forEach((video) => {
            video.setAttribute('autoplay', true);
            video.setAttribute('muted', true);
            video.setAttribute('playsinline', true);
            observer.observe(video);
        });
    }
});